/* eslint-disable react/button-has-type */
import React from 'react';
import classNames from 'classnames';
import styles from './Button.module.css';

export const BUTTON_TYPES = {
  PRIMARY: 'primary',
  PRIMARY_INVERSE: 'primaryInverse',
  TERTIARY: 'tertiary',
  TERTIARY_INVERSE: 'tertiaryInverse',
  CANCEL: 'cancel',
};

const Button = (props) => {
  const {
    type,
    disabled,
    onClick,
    className,
    style,
    children,
    buttonType,
    dataTestId,
    ddActionName,
  } = props;

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      data-dd-action-name={ddActionName}
      className={classNames(styles.button, styles[buttonType], {
        [className]: !!className,
      })}
      style={style}
      data-testid={dataTestId}
    >
      {children}
    </button>
  );
};

Button.defaultProps = {
  type: 'button',
  buttonType: BUTTON_TYPES.TERTIARY,
};

export default Button;
